import React, { useState } from "react";
import { HiOutlineUpload } from "react-icons/hi";
import { FaRegTimesCircle } from "react-icons/fa";
import Loading from "./Loading";
import { S3_BUCKET, S3_BUCKET_RESIZE } from '../../config/constants';
// require("dotenv").config();

function UploadImage(props) {
    const { title, setImage, showImage, setShowImage } = props;
    // const [selectedImg, setSelectedImg] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const selectImage = (e) => {
        setImage(e.target.files[0]);
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onprogress = () => {
            setIsLoading(true);
        }
        reader.onloadend = () => {
            setShowImage(reader.result);
            // setSelectedImg(reader.result);
            setIsLoading(false);
        }

        reader.readAsDataURL(file)
    }

    return (
        <div>
            <div className="m-2 ml-2 block">
                {title}
            </div>
            {isLoading && <Loading />}
            {/* <div className={`text-center ${isLoading ? "block" : "hidden"}`}>
                <div role="status">
                    <svg className="inline mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                    </svg>
                    <span className="sr-only">Loading...</span>
                </div>
            </div> */}
            {
                showImage !== null && showImage !== "/public/" && showImage ? <div className="flex">
                    <label htmlFor={`dropzone-file-${title}`} className="m-auto">
                        <img className="w-auto h-48 rounded-full cursor-pointer" src={showImage.indexOf('public') !== -1 ? `${S3_BUCKET}${showImage.replace("/public/","")}` : showImage} alt="image description" />
                    </label>
                    <FaRegTimesCircle onClick={() => { setImage(null); setShowImage(null) }} className="h-7 w-7 relative right-10 cursor-pointer" />
                </div>
                    :
                    <div className="flex justify-center items-center w-full">
                        <label htmlFor={`dropzone-file-${title}`} className="flex flex-col justify-center items-center w-full h-16 bg-gray-50 rounded-lg border-2 border-purple-700 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                            <div className="flex flex-col justify-center items-center pt-5 pb-6">
                                {/* <HiOutlineUpload className="ml-2 h-7 w-7 text-indigo-700" /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-6 w-6 text-indigo-700" fill="none" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke="blue" stroke-linecap="round" stroke-linejoin="round" d="M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z"/>
                                    <path stroke="blue" stroke-linecap="round" stroke-linejoin="round" d="M17.25 20.25V14.25"/>
                                    <path stroke="blue" stroke-linecap="round" stroke-linejoin="round" d="M17.25 14.25L15 16.5"/>
                                    <path stroke="blue" stroke-linecap="round" stroke-linejoin="round" d="M17.25 14.25L19.5 16.5"/>
                                    <path stroke="blue" stroke-linecap="round" stroke-linejoin="round" d="M8.25 20.25H2.25C1.85218 20.25 1.47064 20.092 1.18934 19.8107C0.908035 19.5294 0.75 19.1478 0.75 18.75V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H12.879C13.2765 0.750085 13.6578 0.907982 13.939 1.189L16.811 4.061C17.092 4.3422 17.2499 4.72345 17.25 5.121V8.25"/>
                                    <path stroke="blue" d="M5.25 6.375C5.04289 6.375 4.875 6.20711 4.875 6C4.875 5.79289 5.04289 5.625 5.25 5.625"/>
                                    <path stroke="blue" d="M5.25 6.375C5.45711 6.375 5.625 6.20711 5.625 6C5.625 5.79289 5.45711 5.625 5.25 5.625"/>
                                    <path stroke="blue" stroke-linecap="round" stroke-linejoin="round" d="M12.085 9.5859L11.25 8.2499C11.1824 8.14826 11.0911 8.06467 10.9838 8.0064C10.8766 7.94814 10.7567 7.91696 10.6347 7.91558C10.5127 7.9142 10.3921 7.94266 10.2836 7.99849C10.1751 8.05431 10.0818 8.13582 10.012 8.2359L8.012 11.0869L6.78 10.0999C6.69884 10.0348 6.60504 9.98739 6.50456 9.96053C6.40408 9.93368 6.2991 9.92802 6.19632 9.94391C6.09353 9.95981 5.99517 9.9969 5.90749 10.0529C5.8198 10.1088 5.74472 10.1824 5.687 10.2689L3.75 14.2499H8.25"/></svg>
                            </div>
                        </label>
                    </div>
            }

            <input id={`dropzone-file-${title}`} accept=".png, .jpg, .jpeg, .svg" onChange={(e) => selectImage(e)} type="file" className="hidden" />

            <div className="mt-2 ml-2 text-sm block text-sitetx-100">
                max. 10 mb
            </div>
        </div>
    );
}

export default UploadImage;
